export const PHONE_TEMPLE_BASE_URL_API = process.env.REACT_APP_PHONE_TEMPLE_BASE_URL_API;
export const PHONE_TEMPLE_BASE_URL_IMG = process.env.REACT_APP_PHONE_TEMPLE_BASE_URL_IMG;
export const PHONE_TEMPLE_BASE_URL = process.env.REACT_APP_PHONE_TEMPLE_BASE_URL;